<template>
  <div class="about">
    <Menu></Menu>
    <Tabber
      :tabberData="tabberData"
      :activeIndex="activeIndex"
      :tabTitle="tabTitle"
      @changeTabber="changeTabber"
    >
      <div slot="tabberContent">
        <div class="aboutSection" v-show="activeIndex == 1" ref="companyInfo">
          <h3 class="title gongsijj">
                        <span class="titleMain">公司简介</span>
                        <span class="titleSub">COMPANY PROFILE</span>
                    </h3>
                    <div class="companyInfo2" ref="companyInfo2"></div>
                    <!-- <div class="sketch">
                        <p class="sketchContent" v-for="(item,index) in listData.content" :key="index">{{item}}</p>
                        <p class="mission">{{listData.mission}}</p>
                    </div>
                    <div class="sketchImg">
                        <img :src="listData.img" alt="">
                    </div> -->
        </div>
        <div class="aboutSection" v-show="activeIndex == 2" ref="companyInfo">
          <h3 class="title gongsijj">
                        <span class="titleMain">企业文化</span>
                        <span class="titleSub">CORPORATE CULTURE</span>
                    </h3>
                    <div class="companyInfo3" ref="companyInfo3"></div>
                    <!-- <div class="sketch">
                        <p class="sketchContent" v-for="(item,index) in listData.content" :key="index">{{item}}</p>
                        <p class="mission">{{listData.mission}}</p>
                    </div>
                    <div class="sketchImg">
                        <img :src="listData.img" alt="">
                    </div> -->
        </div>
        <div class="aboutSection" v-show="activeIndex == 3">
          <h3 class="title">
            <span class="titleMain">荣誉资质</span>
            <span class="titleSub">HONOR</span>
          </h3>
          <div class="sketchImgWrap">
            <div class="sketchImgList" v-for="item in imgList" :key="item.id">
              <img
                :src="item.url"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="aboutSection" v-show="activeIndex == 4">
          <h3 class="title">
            <span class="titleMain">技术支持</span>
            <span class="titleSub">TECHNICAL SUPPORT</span>
          </h3>
          <div class="skillHelp">
            <div class="skillList">
              <img src="../../styles/images/1.png" alt="" />
              <span class="skillMain">{{companyInfo.phone}}</span>
              <span class="skillSub"
                >提供工作日24小时热线电话，及时解答客户问题</span
              >
            </div>
            <div class="skillList">
              <img src="../../styles/images/2.png" alt="" />
              <span class="skillMain">{{companyInfo.email}}</span>
              <span class="skillSub"
                >公司提供24小时邮箱信息交流,及时回复客户需求</span
              >
            </div>
            <div class="skillList">
              <img src="../../styles/images/3.png" alt="" />
              <span class="skillMain">回访</span>
              <span class="skillSub">定期回访,及时进行软件升级与维护</span>
            </div>
            <div class="skillList">
              <img src="../../styles/images/4.png" alt="" />
              <span class="skillMain">联系方式</span>
              <span class="skillSub"
                >通过QQ/微信/谈论组的方式在线实时支撑客户需求</span
              >
            </div>
            <div class="skillList">
              <img src="../../styles/images/5.png" alt="" />
              <span class="skillMain">上门服务</span>
              <span class="skillSub">提供上门服务,为用户解决疑难问题</span>
            </div>
          </div>
        </div>
      </div>
    </Tabber>
  </div>
</template>
<script>
import { getCompanyIntro, getHonorPic ,getCompanyInfo} from "@/api/manage";
import config from "@/config/url.config";
import Menu from "../../components/menu/menu.vue";
import Tabber from "../../components/menu/tabber.vue";
export default {
  components: { Menu, Tabber },
  data() {
    return {
      tabberData: [
        { id: "1", name: "公司简介" },
        { id: "2", name: "企业文化" },
        { id: "3", name: "荣誉资质" },
        { id: "4", name: "技术支持" },
      ],
      activeIndex: "1",
      tabTitle: "关于我们",
      listData: {},
      data: [],
      imgList:[],
      companyInfo:''
    };
  },
  watch: {
    $route(to, from) {
      this.activeIndex = to.params.id;
      this.setInfo(this.activeIndex);
      window.scrollTo(0, 0);
    },
  },
  created() {
  },
  mounted() {
    window.scrollTo(0, 0);
    this.activeIndex = this.$route.params.id;
    this.setInfo(this.activeIndex);
  },
  methods: {
    changeTabber(index) {
      this.$router.push({ name: "aboutUs", params: { id: index } });
    },
    async setInfo(index) {
      let replaceTxt = 'http://116.206.94.117:8195//uploading'
      let newTxt = 'http://101.89.182.189:8191//uploading'
      if (index == 1 || index == 2) {
        console.log('获取新闻3');
        let res = await getCompanyIntro({ type: index });
        if(index==1){
          this.$refs["companyInfo2"].innerHTML = "";
          let text = decodeURI(res.data.text).replace(new RegExp(replaceTxt,'g'),newTxt);
          this.$refs["companyInfo2"].innerHTML += text;
        }else if (res.data) {
          this.$refs["companyInfo3"].innerHTML = "";
          let text = decodeURI(res.data.text).replace(new RegExp(replaceTxt,'g'),newTxt);
          this.$refs["companyInfo3"].innerHTML += text;
        }
      } else if (index == 3) {
        let res = await getHonorPic({ pageNo: 1, pageSize: 999 });
        if (res.data) {
          res.data.forEach((item) => {
            item.url = config.baseURL + item.fileUrl + item.newName;
          });
        }
        console.log('res',res.data);
        this.imgList = res.data
        //console.log("res.data.pictures", res.data.pictures);
      }else if(index==4){
        let res = await getCompanyInfo();
        this.companyInfo=res.data
      }
    },
  },
};
</script>
<style scoped>
.title {
  font-size: 20px;
  line-height: 20px;
  color: #333;
  text-align: center;
}
.title span {
  display: block;
}
.titleSub {
  margin-top: 10px;
  color: #999;
  font-size: 12px;
}
.sketch {
  margin-top: 10px;
}
.sketchTitle,
.featureTitle {
  font-size: 18px;
  color: #666;
  padding-bottom: 10px;
  font-weight: bold;
}
.sketchContent,
.feature p {
  font-size: 14px;
  color: #666;
  line-height: 28px;
  margin-bottom: 0;
}
.sketchContent {
  text-indent: 2em;
}
.titleMain{
  font-size: 25px;
  font-weight: normal;
}
.titleSub{
  font-weight: normal;
}
.sketchImg {
  margin: 60px 0;
  text-align: center;
}
.sketchImg img {
  height: auto;
  width: auto;
  max-width: 1100px;
}
.mission {
  margin-top: 60px;
  font-size: 14px;
  color: #666;
  font-weight: bold;
}
.sketchImgWrap {
  display: flex;
  flex-wrap: wrap;
  margin: 60px 0;
}
.sketchImgList {
  margin: 20px 10px;
}
.sketchImgWrap img {
  width: 230px;
  height: 288px;
}
.skillHelp {
  margin: 60px 0;
  display: flex;
  justify-content: space-between;
}
.skillList {
  text-align: center;
}
.skillList span {
  display: block;
}
.skillList img {
  width: 80px;
  height: 80px;
}
.skillMain {
  font-weight: bold;
  font-size: 16px;
  color: #333;
  margin: 5px 0;
}
.skillSub {
  width: 140px;
  text-align: center;
  color: #666;
  font-size: 12px;
  line-height: 24px;
  margin: 0 auto;
}
.gongsijj{
  margin-bottom: 28px;
}
</style>